<template>
  <div class="form tab-content">
    <input-field
      :value="getValueInObject('tp_label')"
      @input="updateValue('tp_label', $event)"
      :label="$tc('Label', 1)"
      size="small"
      inputType="text"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_address')"
      @input="updateValue('tp_address', $event)"
      :label="$tc('Address', 1)"
      size="medium"
      inputType="text"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_status')"
      @input="updateValue('tp_status', $event)"
      :label="$t('Phase')"
      size="small"
      inputType="select"
      selectOptions="list_statut"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_owner')"
      @input="updateValue('tp_owner', $event)"
      :label="$tc('Owner', 1)"
      size="small"
      inputType="select"
      selectOptions="list_organization"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_pe_concessionaire')"
      @input="updateValue('tp_pe_concessionaire', $event)"
      :label="$tc('Concessionaire', 1)"
      size="small"
      inputType="select"
      selectOptions="list_organization"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_pe_height')"
      :label="$t('Height') + ' (m)'"
      size="small"
      inputType="other"
      :fieldDisabled="readOnly"
    >
      <treeselect
        :value="getValueInObject('tp_pe_height')"
        @input="
          updateValueAndDependentVariables('tp_pe_height', $event, [
            'tp_pe_material',
            'tp_pe_class',
            'tp_pe_nominal_effort'
          ])
        "
        :options="tp_pe_heightOptions"
        :load-options="loadHeightOptions"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field
      :value="getValueInObject('tp_pe_material')"
      :label="$tc('Material', 1)"
      size="small"
      inputType="other"
      :fieldDisabled="readOnly"
    >
      <treeselect
        :value="getValueInObject('tp_pe_material')"
        @input="
          updateValueAndDependentVariables('tp_pe_material', $event, [
            'tp_pe_class',
            'tp_pe_nominal_effort'
          ])
        "
        :options="tp_pe_materialOptions"
        :load-options="loadMaterialOptions"
        :auto-load-root-options="false"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field
      :value="getValueInObject('tp_pe_class')"
      :label="$t('Class')"
      size="small"
      inputType="other"
      :fieldDisabled="readOnly"
    >
      <treeselect
        :value="getValueInObject('tp_pe_class')"
        @input="
          updateValueAndDependentVariables('tp_pe_class', $event, [
            'tp_pe_nominal_effort'
          ])
        "
        :options="tp_pe_classOptions"
        :load-options="loadClassOptions"
        :auto-load-root-options="false"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field
      :value="getValueInObject('tp_pe_nominal_effort')"
      :label="$t('NominalEffort') + ' (kN)'"
      size="small"
      inputType="other"
      :fieldDisabled="readOnly"
    >
      <treeselect
        :value="getValueInObject('tp_pe_nominal_effort')"
        @input="updateNominalEffort('tp_pe_nominal_effort', $event)"
        :options="tp_pe_nominal_effortOptions"
        :load-options="loadNominalEffortOptions"
        :auto-load-root-options="false"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field
      :value="getValueInObject('tp_pe_to_install')"
      label=" "
      input-type="checkbox"
      size="small"
      :field-disabled="readOnly"
    >
      <v-checkbox
        :input-value="getValueInObject('tp_pe_to_install')"
        @change="updateValue('tp_pe_to_install', $event)"
        :label="$t('ToInstall')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
    </input-field>

    <input-field
      value=""
      :label="$t('Effort')"
      size="large"
      inputType="group"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_year')"
      :label="$t('Date')"
      input-type="checkbox"
      size="small"
      :field-disabled="readOnly"
    >
      <v-checkbox
        :input-value="getValueInObject('tp_pe_year_estimated')"
        @change="updateValue('tp_pe_year_estimated', $event)"
        :label="$t('Estimated')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
      <v-checkbox
        :input-value="getValueInObject('tp_pe_year_unreadable')"
        @change="updateValue('tp_pe_year_unreadable', $event)"
        :label="$t('Unreadable')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
    </input-field>

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_year')"
      @input="updateValue('tp_pe_year', $event)"
      :label="$t('Year')"
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_state')"
      @input="updateValue('tp_pe_state', $event)"
      :label="$t('State')"
      size="small"
      inputType="select"
      selectOptions="list_pole_state"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_branch_type')"
      @input="updateValue('tp_pe_branch_type', $event)"
      :label="$t('BranchType')"
      size="small"
      inputType="select"
      selectOptions="list_pole_branch_type"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_green_band')"
      label=" "
      input-type="checkbox"
      size="medium"
      :field-disabled="readOnly"
    >
      <v-checkbox
        :input-value="getValueInObject('tp_pe_green_band')"
        @change="updateValue('tp_pe_green_band', $event)"
        :label="$t('GreenBand')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
      <v-checkbox
        :input-value="getValueInObject('tp_pe_no_calculation')"
        @change="updateValue('tp_pe_no_calculation', $event)"
        :label="$t('NoCalculation')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
    </input-field>

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_hta_equipment')"
      @input="updateValue('tp_pe_hta_equipment', $event)"
      :label="$t('HTAEquipment')"
      size="small"
      inputType="select"
      selectOptions="list_pole_hta_equipment"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_hta_name')"
      @input="updateValue('tp_pe_hta_name', $event)"
      :label="$t('HTAName')"
      size="small"
      inputType="text"
      :fieldDisabled="readOnly"
    />

    <div style="width: 100%" v-if="isElectrical" />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_underground_height')"
      @input="updateValue('tp_pe_underground_height', $event)"
      :label="$t('UndergroundHeight')"
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="getValueInObject('tp_pe_above_ground_height')"
      @input="updateValue('tp_pe_above_ground_height', $event)"
      :label="$t('HeightAboveGround')"
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_light_fixture_height')"
      @input="updateValue('tp_pe_light_fixture_height', $event)"
      :label="$t('LightFixtureHeight')"
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isTelecom"
      :value="getValueInObject('tp_pe_gespot')"
      label="GesPot"
      size="small"
      inputType="other"
      :fieldDisabled="true"
    >
      <treeselect
        :value="getValueInObject('tp_pe_gespot')"
        :options="tp_pe_gespotOption"
        :disabled="true"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field
      v-if="isTelecom"
      :value="getValueInObject('tp_pe_ftth_presence')"
      label=" "
      input-type="checkbox"
      size="small"
      :field-disabled="readOnly"
    >
      <v-checkbox
        :input-value="getValueInObject('tp_pe_ftth_presence')"
        @change="updateValue('tp_pe_ftth_presence', $event)"
        :label="$t('FTTHPresence')"
        :disabled="readOnly"
        color="accent"
        :ripple="false"
      />
    </input-field>

    <input-field
      v-if="isTelecom"
      :value="getValueInObject('tp_pe_copper_branches')"
      @input="updateValue('tp_pe_copper_branches', $event)"
      :label="$t('CopperBranches')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />

    <input-field
      v-if="isTelecom"
      :value="getValueInObject('tp_pe_pb_fiber_type')"
      @input="updateValue('tp_pe_pb_fiber_type', $event)"
      :label="$t('PBFiberType')"
      size="small"
      inputType="select"
      selectOptions="list_pb_fiber_type"
      :fieldDisabled="readOnly"
    />

    <input-field
      value=""
      :label="$t('Standoff')"
      size="large"
      inputType="group"
    />

    <input-field
      :value="objectData.tp_pe_standard_standoff_state"
      label=" "
      size="small"
      input-type="other"
    >
      {{ $t("LowerStandoff") }}
    </input-field>
    <input-field
      :value="getValueInObject('tp_pe_standard_standoff_state')"
      @input="updateValue('tp_pe_standard_standoff_state', $event)"
      :label="$t('State')"
      size="small"
      input-type="radio"
      :radio-options="standoffStates"
      :field-disabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_standard_standoff_height')"
      @input="updateValue('tp_pe_standard_standoff_height', $event)"
      :label="$t('Height')"
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="objectData.tp_pe_mid_standoff_state"
      label=""
      size="small"
      input-type="other"
    >
      {{ $t("MidStandoff") }}
    </input-field>
    <input-field
      :value="getValueInObject('tp_pe_mid_standoff_state')"
      @input="updateValue('tp_pe_mid_standoff_state', $event)"
      label=""
      size="small"
      input-type="radio"
      :radio-options="standoffStates"
      :field-disabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_mid_standoff_height')"
      @input="updateValue('tp_pe_mid_standoff_height', $event)"
      label=""
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="objectData.tp_pe_upper_standoff_state"
      label=""
      size="small"
      input-type="other"
    >
      {{ $t("UpperStandoff") }}
    </input-field>
    <input-field
      :value="getValueInObject('tp_pe_upper_standoff_state')"
      @input="updateValue('tp_pe_upper_standoff_state', $event)"
      label=""
      size="small"
      input-type="radio"
      :radio-options="standoffStates"
      :field-disabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_upper_standoff_height')"
      @input="updateValue('tp_pe_upper_standoff_height', $event)"
      label=""
      size="small"
      inputType="number"
      :fieldDisabled="readOnly"
    />

    <input-field value="" label=" " size="large" inputType="group" />

    <input-field
      :value="getValueInObject('tp_comment')"
      @input="updateValue('tp_comment', $event)"
      :label="$tc('Comment', 1)"
      size="large"
      inputType="textarea"
      :fieldDisabled="readOnly"
    />
  </div>
</template>

<script>
import { poleEffortModuleTabsMixin } from "@/mixins/forms/poleEffortTabsMixin";
import jsonOptions from "@/assets/json/forms/poleEffortFieldOptions.json";
import InputField from "../../_Molecules/InputField";

export default {
  name: "SpecificPoleTab",

  components: { InputField },

  mixins: [poleEffortModuleTabsMixin],

  data() {
    return {
      optionsFromFile: jsonOptions,
      tp_pe_heightOptions: [],
      tp_pe_materialOptions: null,
      tp_pe_classOptions: null,
      tp_pe_nominal_effortOptions: null,
      tp_pe_gespotOption: null
    };
  },

  computed: {
    poleEffortType() {
      if (this.isElectrical) {
        return "BT";
      } else if (this.isTelecom) {
        return "FT";
      }
    },

    standoffStates() {
      return [
        { value: true, label: this.$i18n.t("Existing") },
        { value: false, label: this.$i18n.t("ToInstall") }
      ];
    }
  },

  created() {
    this.loadOptions();
  },

  methods: {
    loadOptions() {
      let fields = this.objectData.pole_effort;
      if (fields) {
        this.getHeightOptions();
        if (fields.tp_pe_height) {
          this.getMaterialOptions();
          if (fields.tp_pe_material) {
            this.getClassOptions();
            if (fields.tp_pe_class) {
              this.getNominalEffortOptions();
            }
          }
        }
      }
    },

    loadHeightOptions({ callback }) {
      this.getHeightOptions();
      callback();
    },

    getHeightOptions() {
      if (this.optionsFromFile) {
        this.tp_pe_heightOptions = this.getOptions(
          this.poleEffortType,
          this.optionsFromFile
        );
      }
    },

    loadMaterialOptions({ callback }) {
      this.getMaterialOptions();
      callback();
    },

    getMaterialOptions() {
      if (this.tp_pe_heightOptions) {
        this.tp_pe_materialOptions = this.getOptions(
          this.objectData.pole_effort.tp_pe_height,
          this.optionsFromFile[this.poleEffortType]
        );
      }
    },

    loadClassOptions({ callback }) {
      this.getClassOptions();
      callback();
    },

    getClassOptions() {
      if (this.tp_pe_materialOptions) {
        this.tp_pe_classOptions = this.getOptions(
          this.objectData.pole_effort.tp_pe_material,
          this.optionsFromFile[this.poleEffortType][
            this.objectData.pole_effort.tp_pe_height
          ]
        );
      }
    },

    loadNominalEffortOptions({ callback }) {
      this.getNominalEffortOptions();
      callback();
    },

    getNominalEffortOptions() {
      if (this.tp_pe_classOptions) {
        this.tp_pe_nominal_effortOptions = this.getOptions(
          this.objectData.pole_effort.tp_pe_class,
          this.optionsFromFile[this.poleEffortType][
            this.objectData.pole_effort.tp_pe_height
          ][this.objectData.pole_effort.tp_pe_material]
        );
      }
    },

    getOptions(parentValue, originalOptions) {
      if (parentValue) {
        {
          let options = [];
          Object.keys(originalOptions[parentValue]).forEach(key =>
            options.push({
              id: key,
              label: key
            })
          );
          options.sort(function(a, b) {
            return parseFloat(a.id) - parseFloat(b.id);
          });
          return options;
        }
      }
      return null;
    },

    updateValueAndDependentVariables(varName, newValue, dependentVariables) {
      this.updateValue(varName, newValue);
      this.resetDependentVariablesValue(dependentVariables);
      this.resetDependentVariableOptions(dependentVariables);
    },

    resetDependentVariablesValue(varNames) {
      varNames.forEach(variable => {
        this.updateValue(variable, undefined);
      });
    },

    resetDependentVariableOptions(varNames) {
      varNames.forEach(variable => {
        this[variable + "Options"] = null;
      });
    },

    updateNominalEffort(varName, newValue) {
      this.updateValue(varName, newValue);
      if (this.isTelecom) {
        let dependentValues = this.optionsFromFile[this.poleEffortType][
          this.objectData.pole_effort.tp_pe_height
        ][this.objectData.pole_effort.tp_pe_material][
          this.objectData.pole_effort.tp_pe_class
        ][this.objectData.pole_effort.tp_pe_nominal_effort];

        this.tp_pe_gespotOption = [
          { id: dependentValues.nomgespot, label: dependentValues.longgespot }
        ];
        this.objectData.pole_effort.tp_pe_gespot = this.tp_pe_gespotOption[0].id;
        this.objectData.pole_effort.tp_pe_height_above_ground = parseFloat(
          dependentValues.hauteur_hors_sol.replace(",", ".")
        );
      }
    }
  },

  watch: {
    poleEffortType() {
      this.updateValue("tp_pe_height", null);
      this.updateValue("tp_pe_material", null);
      this.updateValue("tp_pe_class", null);
      this.updateValue("tp_pe_nominal_effort", null);
      this.loadOptions();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/PoleEffortModule/SpecificPoleTab.vue